import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function Services() {
  const { t } = useLanguage();
  const s = t.services;

  return (
    <section id="services" className="page-section">
      <div className="container">
        <ScrollReveal className="section-head center">
          <span className="section-eyebrow">{s.eyebrow}</span>
          <div className="accent-line center" />
          <h2 className="section-title">{s.title}</h2>
          <p className="section-sub">{s.sub}</p>
        </ScrollReveal>
        <div className="services-grid">
          {s.items.map((item, i) => (
            <ScrollReveal key={item.id} delay={i * 50}>
              <Link to={`/services/${item.id}`} className="service-card" id={item.id}>
                <div className="svc-icon">{item.icon}</div>
                <div className="svc-title">{item.title}</div>
                <div className="svc-desc">{item.desc}</div>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
